//These are for the rest of the nodes
import ContactMailIcon from "@mui/icons-material/ContactMail";
import AddIcon from "@mui/icons-material/Add";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PendingIcon from "@mui/icons-material/Pending";

import ConditionIcon from "../components/flow/nodes/icons/ConditionIcon";
import SMSIcon from "../components/flow/nodes/icons/SMSIcon";
import WaitIcon from "../components/flow/nodes/icons/Wait_Icon";
import WhatsappIcon from "../components/flow/nodes/icons/Whatsapp_Icon";
import AbandonedCartIcon from "../components/flow/nodes/icons/AbandonedCart";
//nodes
import StayedTimeOnPageNode from "../components/flow/nodes/triggers/StayedTimeOnPageNode";
import NewLeadNode from "../components/flow/nodes/triggers/NewLeadNode";
import ExitNode from "../components/flow/nodes/ExitNode";
import ConditionNode from "../components/flow/nodes/actions/ConditionNode";
import WaitNode from "../components/flow/nodes/actions/WaitNode";
import WhatsAppMessageNode from "../components/flow/nodes/actions/WhatsAppMessageNode";
import EmailMessageNode from "../components/flow/nodes/actions/EmailMessageNode";
import SMSMessageNode from "../components/flow/nodes/actions/SMSMessageNode";
import AddedToSegment from "../components/flow/nodes/triggers/AddedToSegment";
import EmailIcon from "../components/flow/nodes/icons/Email_Icon";
import NewLeadIcon from "../components/flow/nodes/icons/NewLead_Icon";
import AddedToSegmentIcon from "../components/flow/nodes/icons/AddedToSegment";
import SQLNode from "../components/flow/nodes/triggers/SQLNode";
import CustomCommandNode from "../components/flow/nodes/actions/CustomCommandNode";
import AbandonedCart from "../components/flow/nodes/triggers/AbandonedCart";
import SendToIcon from "../components/flow/nodes/icons/SendToIcon";
import CrmNode from "../components/flow/nodes/actions/CrmNode";

//Implement hook to get info from user (for "send from" in messsage node, etc.)
// Add this before the nodeTypesConfig object
export const queryTypes = {
  // Table selection as the top level
  table: {
    label: "Table",
    type: "select",
    options: [
      { value: "lead", label: "Lead" },
      { value: "contact", label: "Contact" },
      { value: "campaign", label: "Campaign" },
    ],
    // Each table has its own set of available columns/fields
    subConditions: {
      lead: {
        label: "Field",
        type: "select",
        options: [
          { value: "agreeMail", label: "Agree Mail" },
          { value: "isActive", label: "Is Active" },
          { value: "createdDate", label: "Created Date" },
        ],
        // Field-specific conditions based on data type
        fieldConditions: {
          agreeMail: {
            dataType: "boolean",
            operators: [
              { value: "is", label: "Is" },
              { value: "isNot", label: "Is Not" },
            ],
            valueOptions: [
              { value: "0", label: "No" },
              { value: "1", label: "Yes" },
            ],
          },
          isActive: {
            dataType: "boolean",
            operators: [
              { value: "is", label: "Is" },
              { value: "isNot", label: "Is Not" },
            ],
            valueOptions: [
              { value: "0", label: "Inactive" },
              { value: "1", label: "Active" },
            ],
          },
          createdDate: {
            dataType: "date",
            operators: [
              { value: "is", label: "Is" },
              { value: "isAfter", label: "Is After" },
              { value: "isBefore", label: "Is Before" },
              { value: "isBetween", label: "Is Between" },
            ],
            // No predefined values for dates - user will input
          },
        },
      },
      contact: {
        label: "Field",
        type: "select",
        options: [
          { value: "email", label: "Email" },
          { value: "phone", label: "Phone" },
        ],
        fieldConditions: {
          email: {
            dataType: "string",
            operators: [
              { value: "is", label: "Is" },
              { value: "isNot", label: "Is Not" },
              { value: "contains", label: "Contains" },
              { value: "startsWith", label: "Starts With" },
            ],
          },
        },
      },
    },
  },
};

// Alternative flatter structure that might be easier to work with:
// Updated flatter structure based on approved Excel fields
export const queryTypesFlat = {
  tables: {
    leads: {
      label: "Leads",
      fields: {
        date: {
          label: "Date",
          dataType: "date",
          operators: ["is", "isAfter", "isBefore", "isBetween"],
        },
        email: {
          label: "Email",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        leadStatusId: {
          label: "Lead Status ID",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
        },
        mediaSource: {
          label: "Media Source",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
        mediaChannel: {
          label: "Media Channel",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
        platform: {
          label: "Platform",
          dataType: "string",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "desktop", label: "Desktop" },
            { value: "mobile", label: "Mobile" },
            { value: "tablet", label: "Tablet" },
            { value: "web", label: "Web" },
          ],
        },
        emailOptOut: {
          label: "Email Opt Out",
          dataType: "boolean",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "0", label: "Opted In" },
            { value: "1", label: "Opted Out" },
          ],
        },
        smsOptOut: {
          label: "SMS Opt Out",
          dataType: "boolean",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "0", label: "Opted In" },
            { value: "1", label: "Opted Out" },
          ],
        },
        leadTypeId: {
          label: "Lead Type ID",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
        },
        version: {
          label: "Version",
          dataType: "string",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "A", label: "A" },
            { value: "B", label: "B" },
          ],
        },
        mediaMedium: {
          label: "Media Medium",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
        adCampaignName: {
          label: "Ad Campaign Name",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        adSetName: {
          label: "Ad Set Name",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        utmCampaign: {
          label: "UTM Campaign",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
      },
    },
    engagements: {
      label: "Engagements",
      fields: {
        subject: {
          label: "Subject",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
          settings: {
            min: "0",
            max: "255",
          },
        },
        exSubject: {
          label: "External Subject",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
          settings: {
            min: "0",
            max: "255",
          },
        },
        action: {
          label: "Action",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
          settings: {
            min: "0",
            max: "255",
          },
        },
        label: {
          label: "Label",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
        objectKey: {
          label: "Object Key",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
        context: {
          label: "Context (External)",
          dataType: "string",
          operators: ["is", "isNot", "contains"],
        },
      },
    },
    campaign: {
      label: "Campaign",
      fields: {
        campaignName: {
          label: "Name",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        appType: {
          label: "App Type",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan"],
        },
        startDate: {
          label: "Start Date",
          dataType: "date",
          operators: ["is", "isAfter", "isBefore", "isBetween"],
        },
        endDate: {
          label: "End Date",
          dataType: "date",
          operators: ["is", "isAfter", "isBefore", "isBetween"],
        },
      },
    },
    visits: {
      label: "Visits",
      fields: {
        utmSource: {
          label: "UTM Source",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        utmChannel: {
          label: "UTM Channel",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        utmMedium: {
          label: "UTM Medium",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        utmContent: {
          label: "UTM Content",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        utmCampaign: {
          label: "UTM Campaign",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        version: {
          label: "Version",
          dataType: "string",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "A", label: "A" },
            { value: "B", label: "B" },
          ],
        },
        urlHost: {
          label: "URL Host",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        urlPath: {
          label: "URL Path",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        urlQuery: {
          label: "URL Query",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        country: {
          label: "Country",
          dataType: "string",
          operators: ["is", "isNot"],
        },
        city: {
          label: "City",
          dataType: "string",
          operators: ["is", "isNot"],
        },
        platform: {
          label: "Platform",
          dataType: "string",
          operators: ["is", "isNot"],
          valueOptions: [
            { value: "desktop", label: "Desktop" },
            { value: "Mobile", label: "Mobile" },
            { value: "tablet", label: "Tablet" },
            { value: "Web", label: "Web" },
          ],
        },
        browser: {
          label: "Browser",
          dataType: "string",
          operators: ["is", "isNot", "contains", "startsWith", "endsWith"],
        },
        stayOnPage: {
          label: "Stay On Page",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan", "between"],
        },
        scrollDownPercents: {
          label: "Scroll Down Percents",
          dataType: "number",
          operators: ["is", "isNot", "greaterThan", "lessThan", "between"],
        },
        region: {
          label: "Region",
          dataType: "string",
          operators: ["is", "isNot"],
        },
        language: {
          label: "Language",
          dataType: "string",
          operators: ["is", "isNot"],
        },
      },
    },
  },

  // Operator definitions by data type
  operatorsByType: {
    boolean: [
      { value: "is", label: "Is" },
      { value: "isNot", label: "Is Not" },
    ],
    string: [
      { value: "is", label: "Is" },
      { value: "isNot", label: "Is Not" },
      { value: "contains", label: "Contains" },
      { value: "startsWith", label: "Starts With" },
      { value: "endsWith", label: "Ends With" },
    ],
    number: [
      { value: "is", label: "Equals" },
      { value: "isNot", label: "Does Not Equal" },
      { value: "greaterThan", label: "Greater Than" },
      { value: "lessThan", label: "Less Than" },
      { value: "between", label: "Between" },
    ],
    date: [
      { value: "is", label: "Is" },
      { value: "isAfter", label: "Is After" },
      { value: "isBefore", label: "Is Before" },
      { value: "isBetween", label: "Is Between" },
    ],
  },
};

export const conditionTypes = {
  leadType: {
    type: "select",
    label: "Lead Type",
    options: [
      { value: "basic", label: "Basic Lead" },
      { value: "qualified", label: "Qualified Lead" },
      { value: "customer", label: "Customer" },
    ],
  },
  campaign: {
    label: "Campaign",
    type: "select",
    options: [
      { value: "camp1", label: "Summer Sale 2024" },
      { value: "camp2", label: "New Product Launch" },
      { value: "camp3", label: "Retention Campaign" },
    ],
  },
  emailOptIn: {
    label: "Email Opt-in Status",
    type: "select",
    options: [
      { value: "opted_in", label: "Opted In" },
      { value: "opted_out", label: "Opted Out" },
      { value: "pending", label: "Pending" },
    ],
  },
  messageReturned: {
    label: "Message Returned",
    type: "select",
    options: [
      { value: "accept", label: "Accept" },
      { value: "rejected", label: "Rejected" },
      { value: "any_message_recieved", label: "Any Message Recieved" },
    ],
    subConditions: [
      {
        value: "timeUnit",
        label: "Set Time Unit",
        type: "select",
        options: [
          { value: "seconds", label: "Seconds" },
          { value: "minutes", label: "Minutes" },
          { value: "days", label: "Days" },
          { value: "weeks", label: "Weeks" },
        ],
      },
      { value: "unitAmount", label: "Set Unit Amount", type: "number" },
    ],
  },
};
let nodeTypesConfig = {
  triggers: [
    {
      type: "stayedTimeOnPage",
      displayName: "Stayed X time on Page",
      icon: WaitIcon,
      iconColor: "#ffa726",
      isWip: true,
      formFields: [
        {
          id: "timeUnit",
          label: "Time Unit",
          type: "select",
          required: true,
          options: [
            { value: "minutes", label: "Minutes" },
            { value: "hours", label: "Hours" },
            { value: "days", label: "Days" },
          ],
        },
        {
          id: "timeAmount",
          label: "Amount",
          type: "number",
          required: true,
          min: 1,
        },
        { id: "sendTo", label: "Send To", type: "text", required: true },
        {
          id: "hoursToSkip",
          label: "Hours to Skip",
          type: "timeRange",
          defaultValue: ["09:00", "17:00"],
        },
        {
          id: "daysToSkip",
          label: "Days to Skip",
          type: "checkboxGroup",
          options: [
            { value: "sunday", label: "Sunday" },
            { value: "monday", label: "Monday" },
            { value: "tuesday", label: "Tuesday" },
            { value: "wednesday", label: "Wednesday" },
            { value: "thursday", label: "Thursday" },
            { value: "friday", label: "Friday" },
            { value: "saturday", label: "Saturday" },
          ],
        },
      ],
      nodeComponent: StayedTimeOnPageNode,
    },
    {
      type: "newLead",
      displayName: "New Lead",
      icon: NewLeadIcon,
      iconColor: "#66bb6a",
      isWip: false,
      formFields: [
        {
          id: "leadType",
          label: "Lead Type",
          type: "checkboxGroup",
          required: true,
          options: [
            { value: 1, label: "Usual" },
            { value: 2, label: "Facebook Allow" },
            { value: 3, label: "Click2Call" }, // always came from mobile
            { value: 4, label: "Engagement" },
            { value: 5, label: "CallBack" }, // like Click2Call but always came from web
            { value: 6, label: "Facebook Ads" }, // facebook ads leads
            { value: 7, label: "Overlay" }, // On Site
            { value: 8, label: "Incoming Call" }, // incoming call
            { value: 9, label: "Outgoing Call" }, // outgoing call
            { value: 10, label: "External Lead Api" }, // Leads sent to us from external website via API
            { value: 11, label: "YouTube" }, // incoming leads from YouTube and Google
            { value: 12, label: "Incoming WhatsApp" }, // incoming WhatsApp
            { value: 13, label: "Outgoing WhatsApp" }, // outgoing WhatsApp
            { value: 14, label: "Tiktok Ads" }, // tiktok ads leads
            { value: 15, label: "Statistic Lead" }, // leads that saved just for statistic
          ],
        },
        {
          id: "campaignSource",
          label: "iCreate Campaign Name",
          type: "checkboxGroup",
          required: true,
          options: [
            //This is all replaced later.
            { value: "basic", label: "Campaign 1" },
            { value: "qualified", label: "Vampaign 2" },
            { value: "customer", label: "Campaign 3" },
          ],
        },
      ],
      nodeComponent: NewLeadNode,
    },
    {
      type: "abandonedCart",
      displayName: "Abandoned Cart",
      icon: AbandonedCartIcon,
      iconColor: "#ff7043",
      isWip: true,
      formFields: [
        {
          id: "cartItems",
          label: "Cart Items",
          type: "checkboxGroup",
          required: true,
          options: [
            { value: 1, label: "Electronics" },
            { value: 2, label: "Clothing" },
            { value: 3, label: "Home & Kitchen" },
            { value: 4, label: "Health & Beauty" },
            { value: 5, label: "Sports & Outdoors" },
            { value: 6, label: "Toys & Games" },
            { value: 7, label: "Automotive" },
            { value: 8, label: "Books & Media" },
          ],
        },
        {
          id: "cartValue",
          label: "Cart Value",
          type: "select",
          required: true,
          options: [
            { value: "low", label: "Less than $50" },
            { value: "medium", label: "$50 - $200" },
            { value: "high", label: "More than $200" },
          ],
        },
        {
          id: "returningCustomer",
          label: "Returning Customer",
          type: "checkbox",
          required: false,
        },
        {
          id: "abandonmentTime",
          label: "Time Since Abandonment",
          type: "select",
          required: true,
          options: [
            { value: "1_hour", label: "1 Hour" },
            { value: "6_hours", label: "6 Hours" },
            { value: "24_hours", label: "24 Hours" },
            { value: "3_days", label: "3 Days" },
          ],
        },
      ],
      nodeComponent: AbandonedCart,
    },
    {
      type: "addedToSegment",
      displayName: "Added to Segment",
      icon: AddedToSegmentIcon,
      iconColor: "#26a69a",
      isWip: false,
      formFields: [
        {
          id: "segment",
          label: "Choose Segment",
          required: true,
          type: "checkboxGroup",
          options: [],
        },
        {
          id: "useSharedExit",
          label: "Share Exit Node",
          type: "checkbox",
          defaultValue: false,
        },
      ],
      nodeComponent: AddedToSegment,
    },
    {
      type: "sqlQuery",
      displayName: "SQL Query",
      icon: PendingIcon,
      iconColor: "#26a69a",
      isWip: true,
      formFields: [
        {
          id: "query",
          label: "Write your query",
          required: true,
          type: "text",
          defaultValue: false,
        },
      ],
      nodeComponent: SQLNode,
    },
    // ... other node types
  ],
  actions: [
    {
      type: "waitXTime",
      displayName: "Wait",
      icon: WaitIcon,
      iconColor: "#78909c",
      isWip: false,
      formFields: [
        {
          id: "timeAmount",
          label: "Amount",
          type: "number",
          min: 1,
          required: true,
        },
        {
          id: "timeUnit",
          label: "Unit",
          type: "select",
          required: true,
          options: [
            { value: "minutes", label: "Minutes" },
            { value: "hours", label: "Hours" },
            { value: "days", label: "Days" },
          ],
        },
        {
          id: "daysToSkip",
          label: "Days to Skip",
          type: "checkboxGroup",
          options: [
            { value: "sunday", label: "Sunday" },
            { value: "monday", label: "Monday" },
            { value: "tuesday", label: "Tuesday" },
            { value: "wednesday", label: "Wednesday" },
            { value: "thursday", label: "Thursday" },
            { value: "friday", label: "Friday" },
            { value: "saturday", label: "Saturday" },
          ],
        },
        {
          id: "hoursToSkip",
          label: "Hours to Skip",
          type: "timeRange",
          defaultValue: ["09:00", "17:00"],
        },
      ],
      nodeComponent: WaitNode,
    },
    {
      type: "customNodeCommand",
      displayName: "Custom Query",
      icon: PendingIcon, // or any other icon
      iconColor: "#f48fb1", // any color
      isWip: false,
      formFields: [
        {
          id: "conditions",
          type: "pipeBuilder",
          conditionTypes: queryTypes,
          required: true,
        },
      ],
      nodeComponent: CustomCommandNode,
    },
    {
      type: "conditionNode",
      displayName: "Condition",
      icon: ConditionIcon,
      iconColor: "#9575cd",
      isWip: false, //IS wip, but we are going to be testing it soon so we want it available
      formFields: [
        {
          id: "conditions",
          type: "conditionBuilder",
          conditionTypes: conditionTypes,
          required: true,
        },
      ],
      nodeComponent: ConditionNode,
    },
    {
      type: "whatsappMessage",
      displayName: "WhatsApp Message",
      icon: WhatsappIcon,
      iconColor: "#25D366",
      isWip: false,
      formFields: [
        {
          id: "template",
          label: "Template",
          type: "select",
          options: [
            { value: "wat1", label: "Welcome Message" },
            { value: "wat2", label: "Order Confirmation" },
            { value: "wat3", label: "Appointment Reminder" },
            { value: "wat4", label: "Payment Receipt" },
          ],
        },
      ],
      nodeComponent: WhatsAppMessageNode,
    },
    {
      type: "emailMessage",
      displayName: "Email Message",
      icon: EmailIcon,
      iconColor: "#4fc3f7",
      isWip: false,
      formFields: [
        {
          id: "sendFrom",
          label: "Send From...",
          type: "select",
          options: [
            { value: "em1", label: "support@company.com" },
            { value: "em2", label: "sales@company.com" },
            { value: "em3", label: "marketing@company.com" },
            { value: "em4", label: "noreply@company.com" },
          ],
        },
        {
          id: "subject",
          label: "Subject",
          type: "text",
        },
        {
          id: "template",
          label: "Template",
          type: "select",
          options: [
            { value: "et1", label: "Welcome Email" },
            { value: "et2", label: "Monthly Newsletter" },
            { value: "et3", label: "Password Reset" },
            { value: "et4", label: "Order Confirmation" },
            { value: "et5", label: "Promotional Offer" },
          ],
        },
      ],
      nodeComponent: EmailMessageNode,
    },
    {
      type: "smsMessage",
      displayName: "SMS Message",
      icon: SMSIcon,
      iconColor: "#FF9800",
      isWip: false,
      formFields: [
        {
          id: "sendFrom",
          label: "Send From...",
          type: "select",
          options: [
            { value: "sms1", label: "COMPANY" },
            { value: "sms2", label: "SUPPORT" },
            { value: "sms3", label: "ALERTS" },
            { value: "sms4", label: "+1234567890" },
          ],
        },
        {
          id: "template",
          label: "Template",
          type: "select",
          options: [
            { value: "st1", label: "Verification Code" },
            { value: "st2", label: "Delivery Update" },
            { value: "st3", label: "Appointment Reminder" },
            { value: "st4", label: "Payment Confirmation" },
            { value: "st5", label: "Flash Sale Alert" },
          ],
        },
      ],
      nodeComponent: SMSMessageNode,
    },
    {
      type: "sendToCrm",
      displayName: "Send To CRM",
      icon: SendToIcon,
      iconColor: "#FF9800",
      isWip: false,
      formFields: [
        {
          id: "sendFrom",
          label: "Send From...",
          type: "select",
          options: [
            { value: "sms1", label: "COMPANY" },
            { value: "sms2", label: "SUPPORT" },
            { value: "sms3", label: "ALERTS" },
            { value: "sms4", label: "+1234567890" },
          ],
        },
        {
          id: "template",
          label: "Template",
          type: "select",
          options: [
            { value: "st1", label: "Verification Code" },
            { value: "st2", label: "Delivery Update" },
            { value: "st3", label: "Appointment Reminder" },
            { value: "st4", label: "Payment Confirmation" },
            { value: "st5", label: "Flash Sale Alert" },
          ],
        },
      ],
      nodeComponent: CrmNode,
    },
  ],
  specialNodes: [
    {
      type: "exitNode",
      displayName: "Exit",
      nodeComponent: ExitNode,
    },
  ],
};
export default nodeTypesConfig;
